import { createRoute } from '@tanstack/react-router';

import { AdminBaseRouteLayout } from '$/routes/Admin/AdminBaseRouteLayout';

export const AdminSchoolsRoute = createRoute({
  getParentRoute: () => AdminBaseRouteLayout,
  path: '/admin/schools',
}).lazy(() => import('./AdminSchoolRequestsRoute.lazy').then((d) => d.Route));
